// DuckDB Worker通信の型定義

import type { DataSet } from '../../../types/dataset.types';
import type { DataSchema } from '../../../types/core.types';
import type { OperationResult } from '../executeOperation';
import type { TableReference } from './index';

/**
 * メインスレッド → Worker へのメッセージ
 */
export type DuckDBWorkerRequest =
  | { type: 'init'; id: number }
  | {
      type: 'executeSQL';
      id: number;
      query: string;
      targetDataset: DataSet;
      datasets: Record<string, DataSet>;
      existingSchema?: DataSchema;
    }
  | { type: 'clearAllTables'; id: number }
  | { type: 'extractTableReferencesWithLocation'; id: number; query: string };

/**
 * Worker → メインスレッド へのレスポンス
 */
export type DuckDBWorkerResponse =
  | { type: 'ready'; id: number }
  | { type: 'result'; id: number; result: OperationResult }
  | { type: 'cleared'; id: number }
  | { type: 'tableReferences'; id: number; references: TableReference[] }
  | { type: 'error'; id: number; error: string };

/**
 * キャンセル時にthrowされるエラー
 */
export class DuckDBCancelledError extends Error {
  constructor() {
    super('Operation cancelled');
    this.name = 'DuckDBCancelledError';
  }
}
